<template>
  <div class="advisory">
    <div class="line"></div>
    <van-tabs v-model="newsId" title-active-color="#353535" @change="changeVal">
      <van-tab
        v-for="item in tabAttr"
        :title="item.name"
        :name="item.id"
        :key="item.id"
      >
        <!-- <slot :name="item.slotName"></slot> -->
        <!-- <news-list></news-list> -->
        <div
          v-for="(item, index) in dataDetail"
          :key="index"
          @click="goDetail(item)"
        >
          <div class="list-box">
            <p class="news-p">{{ item.newsTitle }}</p>
            <div class="news-box">
              <div class="box-item">
                <!-- <div class="list-textP van-multi-ellipsis--l2" v-html="item.newsRemarksAll"></div> -->
                <div
                  class="list-textP van-multi-ellipsis--l2"
                  v-html="item.directions"
                ></div>
                <div class="list-bottom">
                  <img src="@/images/read_icon.png" />
                  <span class="list-num">{{ item.readCounts }}</span>
                  <span class="list-right">{{ item.createTime }}</span>
                </div>
              </div>
              <div class="box-item1">
                <img class="right-img" :src="item.fileUrl" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="noDate && dataDetail.length == 0">
          <van-empty
            class="custom-image"
            :image="require('../../../assets/images/null@2x.png')"
            description=""
          />
        </div>
      </van-tab>
    </van-tabs>
    <van-cell
      v-if="tabAttr.length != 0"
      title="查看更多"
      is-link
      @click="moreData"
    />
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import { Tab, Tabs } from "vant";
import newsList from "./newsList";
import { toast } from "@/common/api/api.js";
import { addNewsPointBeforeRedirect } from "@/common/api";
Vue.use(Tab);
Vue.use(Tabs);
export default {
  props: {
    newsType: {
      type: Array,
    },
    newTypeDetail: {
      type: Array,
    },
  },
  components: {
    newsList,
  },
  watch: {
    newsType(val) {
      if (val.length != 0) {
        this.tabAttr = val;
      }
    },
    newTypeDetail(val) {
      if (val.length == 0) {
        this.noDate = true;
      }
      this.dataDetail = val;
    },
  },
  data() {
    return {
      noDate: false, //没有数据时的控制字段
      newsId: "", //资讯分类的id
      dataDetail: {}, //资讯详情数据
      tabAttr: [
        // {
        //   state: "newNums",
        //   slotName: "slotNews",
        //   title: "新闻资讯"
        // },
        // {
        //   state: "zcwj",
        //   slotName: "slotZcwj",
        //   title: "政策文件"
        // },
        // {
        //   state: "yxjy",
        //   slotName: "slotYxjy",
        //   title: "医学教育"
        // },
        // {
        //   state: "kpzs",
        //   slotName: "slotKpzs",
        //   title: "科普知识"
        // },
        // {
        //   state: "lmxc",
        //   slotName: "slotLmxc",
        //   title: "劳模宣传"
        // }
      ],
    };
  },
  created() {
    // this.tabAttr = this.newsType;
    // this.newsId = this.tabAttr[0].id;
  },
  beforeRouteLeave(to, from, next) {},
  methods: {
    // 跳转资讯详情页面
    goDetail(item) {
      if (item.redirectUrl) {
            addNewsPointBeforeRedirect({ id: item.id }).then((res) => {
          const { code, message, data } = res;
          if (code == 200) {
            location.href = item.redirectUrl;
          } else {
            toast(this, message, "error");
          }
        });
      } else {
        this.$router.push({
          path: "/consultDetail",
          query: {
            consultDetailId: item.id,
          },
        });
      }
    },
    changeVal(id) {
      console.log(id);
      this.$emit("getNewsId", id); //把当前资讯id传递给父组件
    },
    // 调用父组件的页面跳转到更多资讯列表方法
    moreData(id) {
      this.$emit("goList");
    },
  },
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/index.styl';
@import '../../../assets/stylus/reset.css';

.advisory {
  background: #fff;

  >>>.van-empty__image {
    width: 100px;
    height: 100px;
  }

  .van-empty {
    padding: 10px 0;
  }

  >>>.van-empty__description {
    margin-top: 0px;
  }
}

.advisory >>> .van-tab--active {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #353535;
}

.advisory >>> .van-tab {
  color: #353535;
}

.advisory >>> .van-tab__text {
  font-weight: 500;
}

.advisory >>> .van-tab--active .van-tab__text {
  font-weight: 600;
}

.list-textP >>> p {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  display: inline;
}

.list-textP >>> ol, span, ol, li, ul, h1, h2, strong, em, pre {
  display: inline;
}

.list-textP >>> img, br {
  display: none;
}

.list-textP {
  br {
    diaplay: none;
  }
}

.van-tabs__line {
  background-color: $main-bgColor;
}

.list-box {
  padding: 10px 15px 15px;
  border-bottom: 1px solid #EFEFF4;

  .news-p {
    color: #353535;
    font-size: 15px;
    padding: 0 0 10px;
    font-weight: 700;
  }

  .news-box {
    display: flex;

    .box-item1 {
      text-align: right;
      margin-left: 10px;
      width: 70px;

      .right-img {
        min-width: 70px;
        min-height: 50px;
        max-width: 90px;
        max-height: 65px;
        // width:72px;
        // height:65px;
        border-radius: 4px;
      }
    }

    .box-item {
      flex: 1;
      width: 0;

      .list-textP {
        color: #888888;
        font-size: 13px;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        // height: 38px;
      }

      .right-img {
        width: 52%;
      }

      .list-bottom {
        color: #CACAD2;
        font-size: 12px;
        position: relative;
        margin-top: 5px;

        .list-num {
          vertical-align: middle;
        }

        .list-right {
          position: absolute;
          top: 1vw;
          bottom: 0;
          right: 0;
          margin: auto;
        }
      }
    }
  }
}

.line {
  height: 10px;
  background: #F4F5F9;
}

.van-cell {
  justify-content: center;
  background: #F4F5F9;
}

.van-cell__title {
  flex: none;
}
</style>